import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {CurrentEnvironmentConfigService} from '../../../services/common/currentEnvironmentConfig.service';
import {GhostComponent} from '../../../utils/ghostComponent';
import {SafeUrl} from '@angular/platform-browser';
import {IziviaSafeUrlService} from '../../../services/common/iziviaSafeUrl.service';

@Component({
    selector: 'remote-img',
    templateUrl: './remoteImg.component.html',
    styleUrls: ['./remoteImg.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {'class': 'fullSize'}
})
export class RemoteImgComponent extends GhostComponent implements OnChanges {
    @Input() src;
    @Input() alt: string;
    @Input() ghostClass: string = '';
    @Input() displayMode: 'cover' | 'plug' | 'contain' = 'contain';
    @Input() set fallbackSrc(src: string) {
        this._fallbackSrc = this.safeUrlService.toSafeURL(src);
    }

    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() load: EventEmitter<Event> = new EventEmitter();
    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() error: EventEmitter<ErrorEvent> = new EventEmitter();

    remoteImgUrl:  SafeUrl;
    baseUrl: string;

    private _fallbackSrc: SafeUrl;

    constructor(currentEnvironmentConfigService: CurrentEnvironmentConfigService,
        private readonly safeUrlService: IziviaSafeUrlService) {
        super();
        currentEnvironmentConfigService.getCurrentBaseUrl()
            .subscribe(baseUrl => this.baseUrl = baseUrl);
    }

    ngOnChanges(changes: SimpleChanges): void {
        // if there is a src changes then we need to activate ghost mode while image load/error
        if (changes.src) {
            const currentValue: string = changes.src.currentValue;
            const previousValue: string = changes.src.previousValue;

            // considering a changes only if current !== previousValue
            // the second part is aim to check a currentValue = null and previousValue = undefined and define it at the same value
            if (currentValue !== previousValue && (currentValue || previousValue)) {
                this.ghostMode = true;

                // if no value then use fallback
                if (!currentValue) {
                    this.remoteImgUrl = this.safeUrlService.toSafeURL(this.fallbackSrc);
                } else {
                    // if current value start with '/', it is a server URL
                    if (currentValue.startsWith('/')) {
                        this.remoteImgUrl = this.safeUrlService.toSafeURL(this.baseUrl + currentValue);
                    } else {
                        this.remoteImgUrl = this.safeUrlService.toSafeURL(currentValue);
                    }
                }
            }
        }
    }

    public onLoad($event: Event) {
        this.ghostMode = false;
        this.load.emit($event);
    }

    public onError($event: ErrorEvent) {
        if (this.remoteImgUrl !== this.fallbackSrc) {
            this.remoteImgUrl = this.fallbackSrc;
        } else {
            this.ghostMode = false;
        }

        this.error.emit($event);
    }

    generateGhost(): void {
    }
}
